import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-remove-user',
    templateUrl: './remove-user.component.html',
    styleUrls: ['./remove-user.component.scss'],
    standalone: false
})
export class RemoveUserComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<RemoveUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
  }
  cancel(){
    this.dialogRef.close(false);
  }
  removeMember() {
    this.dialogRef.close(true);
  }


}
